import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { Checkbox } from '@getro/rombo';
import PropTypes from 'prop-types';
import { TableHeaderTitle } from '../../dataTable/components/tableHeaderTitle';
import { TableHeaderSort } from './tableHeaderSort';

const getProps = (props) => {
  const groupKey = props.column.colDef.showRowGroup;
  return props.context.columns?.[groupKey]?.headerComponentParams ?? props;
};

export const TableHeader = ({ column, api, ...props }) => {
  const { displayName, tooltip, hideColumn, sortedBy, field, handleSort, disableSortBy, columnSelection } = getProps({
    ...props,
    column,
  });

  return (
    <Box
      sx={{
        zIndex: 10,
        top: 0,
        left: 0,
        backgroundColor: 'white',
        fontSize: 12,
        fontWeight: 400,
        lineHeight: 1.68,
        letterSpacing: 1,
        color: 'text.subtle',
        textTransform: 'uppercase',
        padding: '8px',
        textAlign: 'left',
        borderColor: 'border.subtle',
        width: '100%',
        ':hover': {
          [`#${field}`]: {
            visibility: 'visible',
          },
        },
      }}
    >
      <Flex sx={{ justifyContent: 'space-between', width: '100%', alignItems: 'center', gap: '8px' }}>
        <TableHeaderTitle Header={displayName} tooltip={tooltip} />

        <Flex sx={{ gap: '8px' }}>
          {field && (
            <TableHeaderSort
              hideColumn={hideColumn}
              handleSort={handleSort}
              sortedBy={sortedBy}
              column={{
                accessor: field,
                disableSortBy,
              }}
            />
          )}
          {columnSelection && (
            <Checkbox
              key={column.colId}
              onChange={(e) => {
                if (e.target.checked) {
                  api.clearRangeSelection();
                  api.setFocusedCell(0, column.colId);
                  api.addCellRange({
                    rowStartIndex: 0,
                    rowEndIndex: api.getDisplayedRowCount(),
                    columnStart: column.colId,
                    columnEnd: column.colId,
                  });
                } else {
                  api.clearRangeSelection();
                }
              }}
            />
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

TableHeader.propTypes = {
  column: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  api: PropTypes.object.isRequired,
};
